// extracted by mini-css-extract-plugin
export default {"button":"CVAndCoverLetter_button__PaFUT","fileSizeNote":"CVAndCoverLetter_fileSizeNote__b0DI2"};